<template>
  <div class="e-block-wrap">
    <div class="e-block">
      <div class="e-block__scroll" :style="{ minHeight: containerHeight }">
        <div class="e-block__call">
          <div class="e-block__call-img"></div>
          <div class="e-block__title">Call {{ phoneNumber }}</div>
          <div class="e-block__call-copy" @click="copy">{{ copyText }}</div>
          <div class="e-block__text e-block__text--call e-block__text--mb32">Our customer experience representative is on the other end of the line. You can call when you’re ready.</div>
        </div>
      </div>
    </div>
    <div class="e-bottom-navbar">
      <div class="e-row">
        <div class="e-col-auto e-col-sm-12">
          <button class="e-btn e-btn--prev" @click.prevent="previous">Previous</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

const initCopyText = 'Copy to clipboard';
export default {
  components: {},
  name: 'NeedHelp',
  data() {
    return {
      phoneNumber: process.env.VUE_APP_PHONE,
      copyText: initCopyText,
    };
  },
  mounted() {},
  computed: {
    ...mapState(['containerHeight']),
  },
  methods: {
    ...mapActions(['previousQuestion']),
    previous() {
      this.previousQuestion();
    },
    async copy() {
      await navigator.clipboard.writeText(this.phoneNumber);
      this.copyText = 'Copied!';
      setTimeout(() => {
        this.copyText = initCopyText;
      }, 3000);
    },
  },
};
</script>

<style lang="scss">

</style>
